import { useEffect } from 'react';
import { identifyUser as identifyMonitoringUser } from 'shared/services/MonitoringService';
import { AppLayout } from './AppLayout';
import { MarketingLayout } from './MarketingLayout';
import { PricingInsightsPage } from './pages/carrier-pay/PricingInsightsPage';
import { isUserFromSuperDispatch } from './pages/carrier-pay/unlock/UnlockUtils';
import {
  getAnonymousId,
  identifyUser,
  trackEvent,
} from './services/AnalyticsService';

export function App() {
  useEffect(() => {
    trackEvent('Opened Pricing Insights');

    identifyUser().then((analyticsUserId) => {
      const analyticsAnonymousId = getAnonymousId();

      identifyMonitoringUser({
        analytics_user_id: analyticsUserId,
        analytics_anonymous_id: analyticsAnonymousId,
      });
    });
  }, []);

  const Layout = isUserFromSuperDispatch() ? AppLayout : MarketingLayout;
  return (
    <Layout>
      <PricingInsightsPage />
    </Layout>
  );
}
